import {
  DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_DIMENSIONS,
  DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES,
  PLAYBOOKS_CHAT_DIMENSIONS,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const PlaybookPerformanceCSVExportQuery: CubeQuery = {
  name: 'PlaybookPerformanceCSVExportQuery',
  queryName: 'PlaybookPerformanceCSVExportQuery',
  query: {
    measures: [
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_IMPRESSIONS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_SENDS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_CONVERSATIONS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_EMAILS_CAPTURED,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.COUNT_MEETINGS_BOOKED,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_MEASURES.AVG_CQL_SCORE,
    ],
    dimensions: [
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_NAME,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_DIMENSIONS.PLAYBOOK_ID,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_STATUS,
      DRIFT_CHAT_BLENDED_PLAYBOOK_METRICS_DIMENSIONS.BOT_FLOW,
    ],
  },
}
